import Http from '@/services/Http';

const path = 'envelopes/webhooks';
const client = new Http(path);

client.listEvents = (webhookId, params = {}) =>
  client.get(`${webhookId}/events`, { extended: 'true', ...params });

client.fetchEventsByDateInterval = (webhookId, dateFrom, dateTo, params = {}) =>
  client.get(`${webhookId}/events/interval`, {
    extended: 'true',
    date_from: dateFrom,
    date_to: dateTo,
    ...params,
  });

client.retryEvent = (webhookId, eventId) =>
  client.post('', `${path}/${webhookId}/events/${eventId}/retry`);

export default client;
